import {Component, Input, OnInit} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import {
  ActionResult,
  Country,
  EventItem,
  FetchEventByIdRequest, League,
  Lookups,
} from "@model";
import {
  AuthenticationService,
  EventService, LoaderService,
  TOAST_STATE,
  ToastService
} from "@services";
import {AbstractComponent} from "../abstract.component";
import {DatePipe} from '@angular/common';
import {environment} from "@environment";

@Component({
  selector: 'app-league-grid-item-with-image',
  templateUrl: './league-grid-item-with-image.component.html',
  styleUrls: ['./league-grid-item-with-image.component.scss'],
  providers: [DatePipe]
})
export class LeagueGridItemWithImage extends AbstractComponent implements OnInit {
  @Input() league: League | undefined;
  @Input() additionalClass: string | undefined;
  @Input() isFinishedLeague: boolean = false;
  @Input() countries: Country[] = [];
  @Input() isOnWishList: boolean = false;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() favoriteItems?: EventItem[];
  @Input() isItemFavorite: boolean = false;
  @Input() isPreviewComponent?: boolean;
  @Input() zoomEffect: boolean = false;

  lengths: (string | undefined)[] = [];

  constructor(public translocoService: TranslocoService, private authenticationService: AuthenticationService,
              private eventService: EventService, private toastService: ToastService, private loaderService: LoaderService) {
    super();
  }

  ngOnInit(): void {
    this.isFavorite(this.league);
  }

  isFavorite(item: EventItem | undefined): void {
    if (item) {
      this.isItemFavorite = !!(this.favoriteItems && this.favoriteItems.find(value => item.id === value.id));
    }
  }

  addToFavoritesButtonClicked(event: MouseEvent): void {
    if (this.isPreviewComponent) {
      event.preventDefault()
      event.stopPropagation()
      return;
    } else {
      event.preventDefault()
      event.stopPropagation()
      if (this.authenticationService.isAuthenticated()) {
        this.addToFavoritesAction();
      } else {
        this.toastService.showToast(TOAST_STATE.warning, this.translocoService.translate("event.favorite.save.warning"));
      }
    }
  }

  addToFavoritesAction(): void {
    this.loaderService.startLoading()
    if (this.league?.id) {
      this.eventService.findEventById(new FetchEventByIdRequest(this.league.id)).subscribe((value: EventItem | null) => {
        if (value) {
          if (value.id && value.favorite) {
            this.eventService.removeEventFromFavorites(this.league?.id).subscribe((actionResult: ActionResult<boolean>) => {
              if (actionResult.result) {
                this.isItemFavorite = false;
                this.eventService.fetchUserFavoritesEvent().subscribe((actionResult: EventItem[]) => {
                  this.favoriteItems = actionResult;
                  this.loaderService.dismissLoading();
                });
              } else {
                this.loaderService.dismissLoading();
              }
            });
            this.toastService.showToast(TOAST_STATE.success, this.translocoService.translate("event.favorite.delete.success"));
          } else if (value.id && !value.favorite) {
            this.eventService.addEventToFavorites(value.id).subscribe((actionResult: ActionResult<boolean>) => {
              if (actionResult.result) {
                this.isItemFavorite = true;
                this.loaderService.dismissLoading();
              } else {
                this.loaderService.dismissLoading();
              }
            });
            this.toastService.showToast(TOAST_STATE.success, this.translocoService.translate("event.favorite.save.success"));
          }
        }
      })
    }
  }

  protected readonly environment = environment;
}
